module.exports = __webpack_public_path__ + "static/media/quarto.3f7bfd8f.svg";